import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import ContentPanel from '../contentPanel/index';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import Close from '@material-ui/icons/Close';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { map } from '../../map/map';
import { GREY300 } from '../../colors';

const styles = theme => ({
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '5px'
  },
  formControl: {
    backgroundColor: 'rgb(238,238,238)',
    color: GREY300,
    overflow: 'auto'
  },
  input: {
    fontFamily: 'Pluto Sans Cond Bold',
    fontSize: '0.88em',
    paddingLeft: '8px',
  },
  icon: {
    height: '35px',
    width: '35px',
  },
  resultsList: {
    maxHeight: '300px',
    overflowY: 'auto'
  },
  text: {
    fontFamily: 'Pluto Sans Cond Bold'
  },
  noResults: {
    fontFamily: 'Pluto Sans Cond Bold',
    fontSize: '0.88em',
    marginLeft: '8px',
    marginTop: '3px',
  }
});

class PersonSearch extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchText: '',
      selectedSuggestion: {}
    }
  }

  handleChange = (e) => {
    const searchTerm = e.target.value;
    this.setState({ selectedSuggestion: {} });
    this.setState({ searchText: searchTerm });
    this.props.onChange(searchTerm);
  }

  handleDelete = () => {
    this.setState({ selectedSuggestion: {} });
    this.setState({ searchText: '' });
    this.props.onChange('');
  }

  handleClickSuggestion = (suggestion) => {
    map.getView().setZoom(17);

    this.setState({ selectedSuggestion: suggestion, searchText: suggestion['properties']['name'] });
    this.props.onChange('');   
    
    const extent = [
      suggestion['geometry']['coordinates'][0], 
      suggestion['geometry']['coordinates'][1], 
      suggestion['geometry']['coordinates'][0], 
      suggestion['geometry']['coordinates'][1]
    ];
    map.getView().fit(extent, map.getSize());

    if (this.props.mapMenus.filter(x => x.id === 'deported_pop' && x.active).length == 0){
      this.props.setDeportedLayer();
    }
  }

  render() {
      const { classes, enabled, response, formState, startSending } = this.props;
      const { searchText, selectedSuggestion } = this.state;
      
      if(!enabled) {
        return null;
      }

      let key = 0;
      
      return (
        <ContentPanel
            HeaderIcon={<SearchIcon className={classes.icon} viewBox='-9 -7 40 40' />}
            enabled={enabled}
            HeaderText={window.displayText('PERSON_SEARCH')}
            onClose={this.props.closeHandler}
        >
          <div className={classes.contentContainer}>
            <FormControl className={classes.formControl}>
              <Input
                name='person_search'
                autoComplete='off'
                style={{ overflow: 'hidden' }}
                value={searchText}
                disableUnderline={true}
                placeholder={window.displayText('SEARCH_PERSON_OR_ADDRESS')}
                className={classes.input}
                onChange={this.handleChange}
                onKeyPress={this.handleEnter}
                endAdornment={<div style={{ display: 'flex', flexDirection: 'row' }}>{searchText.length > 0 &&
                  <InputAdornment position='start' style={{ position: 'relative', verticalAlign: 'top' }}><Close onClick={this.handleDelete} style={{ fontSize: '20px', cursor: 'pointer' }} /></InputAdornment>
                }
                </div>}
              />
            </FormControl>
              
            {!startSending && formState == 'finished' && response['features'].length == 0 && searchText.length > 3 && !('type' in selectedSuggestion) && <span className={classes.noResults}>Nekas netika atrasts!</span>}

            <List disablePadding className={classes.resultsList}>
              {response['features'].map(feature => (            
                <ListItem button key={key++} onClick={(e) => this.handleClickSuggestion(feature)}>
                  <ListItemText
                    classes={{
                      primary: classes.text,
                      secondary: classes.text,
                    }}                  
                    primary={feature['properties']['name']}
                    secondary={feature['properties']['address']}
                  />
                </ListItem>
              ))}                
            </List>
          </div>

        </ContentPanel>
      );
  }
}

PersonSearch.propTypes = {
  classes: PropTypes.object.isRequired,
  enabled: PropTypes.bool.isRequired,
  closeHandler: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  response: PropTypes.object.isRequired
};

export default withStyles(styles)(PersonSearch);


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/personSearch/index.js